import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {useTaxesInformation} from './TaxesInformationContent-hook'

export const TaxesInformationContent = ({taxesinformationData}) => {
  const {taxesinformationJsonSchema, taxesinformationUISchema} = useTaxesInformation()
  const getVal = v => v || '-'
  return (
    <div>
      <JsonFormsWrapper
        jsonschema={taxesinformationJsonSchema}
        uischema={taxesinformationUISchema}
        data={{
          name: getVal(taxesinformationData?.name),
          type: getVal(taxesinformationData?.type),
          value: getVal(taxesinformationData?.value),
        }}
      />
    </div>
  )
}
